import React from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import Skeleton from "react-loading-skeleton";
import withCustomStyles from "./CategoriesHorizontalPart.style";
import CategoryHorizontalTilePart from "./CategoryHorizontalTilePart";
import { GRail } from "./ui";
import { scrollBehavior } from "../utils/HelperUtils";

// "Shop by category" rail of round tiles. `categories` defaults to all
// top-level categories from the store.
@inject(["categoriesStore"])
@observer
class CategoriesHorizontalPart extends React.Component {
  // Deals disc (brand tint, "%"): first tile on Home, jumps to the deals rail
  handleDealsClick = event => {
    const target = document.getElementById(this.props.dealsAnchor);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: scrollBehavior(), block: "start" });
  };

  renderDealsTile() {
    const { classes, dealsAnchor } = this.props;
    return (
      <a
        key="deals"
        href={`#${dealsAnchor}`}
        onClick={this.handleDealsClick}
        className={classes.dealsTile}
      >
        <span className={classes.dealsDisc} aria-hidden="true">
          %
        </span>
        <span className={classes.dealsName}>Deals</span>
      </a>
    );
  }

  render() {
    const {
      classes,
      isBottom,
      sendEvent,
      categoriesStore,
      title,
      seeAllTo,
      categories,
      fetchState,
      dealsAnchor
    } = this.props;
    const list = categories || categoriesStore.all;
    const state = fetchState || categoriesStore.state;
    const loading = list.length === 0 && state === "fetching";

    if (!loading && list.length === 0) {
      return null;
    }

    return (
      <GRail
        title={title}
        seeAllTo={seeAllTo}
        kind="category"
        ariaLabel={title}
      >
        {loading
          ? Array.from({ length: 12 }, (_, i) => (
              <div key={i} className={classes.skeleton} aria-hidden="true">
                <Skeleton circle width={84} height={84} />
                <Skeleton width={72} height={14} />
              </div>
            ))
          : [
              dealsAnchor && this.renderDealsTile(),
              ...list.map(
                category =>
                  category && (
                    <CategoryHorizontalTilePart
                      key={category.id}
                      isBottom={isBottom}
                      sendEvent={sendEvent}
                      category={category}
                    />
                  )
              )
            ]}
      </GRail>
    );
  }
}

CategoriesHorizontalPart.propTypes = {
  title: PropTypes.node,
  seeAllTo: PropTypes.string,
  categories: PropTypes.array,
  fetchState: PropTypes.string,
  sendEvent: PropTypes.bool,
  isBottom: PropTypes.bool,
  dealsAnchor: PropTypes.string
};

CategoriesHorizontalPart.defaultProps = {
  title: "Shop by category",
  seeAllTo: "/categories"
};

export default withCustomStyles(CategoriesHorizontalPart);
